import { TextField, TextFieldProps, InputAdornment } from "@mui/material";
import { Controller, Control, FieldPath, FieldValues } from "react-hook-form";

interface FormNumberFieldProps<T extends FieldValues>
  extends Omit<TextFieldProps, "name" | "value" | "onChange" | "type"> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
  placeholder?: string;
  required?: boolean;
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
}

export const FormNumberField = <T extends FieldValues>({
  name,
  control,
  label,
  placeholder,
  required = false,
  min,
  max,
  step,
  unit,
  ...textFieldProps
}: FormNumberFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...textFieldProps}
          label={label}
          placeholder={placeholder}
          type="number"
          error={!!error}
          helperText={error?.message || textFieldProps.helperText}
          required={required}
          variant={textFieldProps.variant || "standard"}
          inputProps={{
            min,
            max,
            step,
            ...textFieldProps.inputProps,
          }}
          InputProps={{
            endAdornment: unit && (
              <InputAdornment position="end">{unit}</InputAdornment>
            ),
            ...textFieldProps.InputProps,
          }}
          onChange={(e) => {
            const value = e.target.value;

            field.onChange(value === "" ? "" : Number(value));
          }}
        />
      )}
    />
  );
};
